var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.promos.length)?_c('div',_vm._l((_vm.promos),function(promo){return _c('div',{key:promo,staticClass:"banner"},[_c('html-with-links',{staticClass:"banner__inner container",attrs:{"tag":"p","html":promo}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }